module.exports = __webpack_public_path__ + "img/product-example-big.d8053074.svg";